import Column from '@amzn/meridian/column';
import styled from '@emotion/styled';
export const HeroContainer = styled.div `
  position: relative;
  width: 100%;
  max-width: 100vw;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => theme.rio.semantic.color.background.primary};
`;
export const HeroImage = styled.img `
  width: 100%;
  height: auto;
  object-fit: contain;
  max-height: 60vh;
`;
// Single product list with layout prop
export const ProductList = styled(Column) `
  margin: ${({ layout = 'horizontal' }) => (layout === 'horizontal' ? '8px 0px' : '8px 18px')};
`;
// Single grid with columns prop
export const ProductGrid = styled.div `
  display: grid;
  grid-template-columns: ${({ columns = 1 }) => `repeat(${columns}, 1fr)`};
  gap: 8px;
  ${({ columns }) => columns === 2 && 'margin: 16px;'}
`;
